import { render } from "./PersonnelDetailModal.vue?vue&type=template&id=6bec6971&scoped=true"
import script from "./PersonnelDetailModal.vue?vue&type=script&lang=js"
export * from "./PersonnelDetailModal.vue?vue&type=script&lang=js"

import "./PersonnelDetailModal.vue?vue&type=style&index=0&id=6bec6971&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bec6971"]])

export default __exports__